var map = {
	"./adsorb.svg": "47fc",
	"./align-bottom.svg": "a834",
	"./align-center.svg": "7b26",
	"./align-left.svg": "fb17",
	"./align-right.svg": "c56a",
	"./align-top.svg": "9bb1",
	"./angle.svg": "3b19",
	"./arrow-left.svg": "12e3",
	"./arrow-right.svg": "6929",
	"./choose.svg": "720a",
	"./copy.svg": "19b6",
	"./cube.svg": "16d2",
	"./exitFull.svg": "a594",
	"./fullscreen.svg": "9921",
	"./image.svg": "8736",
	"./light.svg": "7748",
	"./reset.svg": "9b4b",
	"./rotate-view.svg": "4e63",
	"./rotate.svg": "e1a6",
	"./search.svg": "8e8d",
	"./set.svg": "9873",
	"./sun.svg": "a776",
	"./texture.svg": "176d",
	"./translation.svg": "044c",
	"./vlign-center.svg": "991c",
	"./volume.svg": "cf79",
	"./zoom.svg": "406f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";